import 'core-js/es6/promise'

export const isServer = typeof window === `undefined`
export const modernBrowser = isServer || ('fetch' in window && 'assign' in Object)

//isFinite polyfill
if (Number.isFinite === undefined)
  Number.isFinite = function(value) {
    return typeof value === 'number' && isFinite(value)
  }

// todo: these could be bundled for non modern browsers
export default () =>
  modernBrowser
    ? Promise.resolve(false)
    : Promise.all([
        import('url-polyfill'),
        import('whatwg-fetch'),
        import('core-js/es6/array/'),
        import('core-js/es6/object/assign'), // useBuiltIns=false
        import('core-js/es6/number/is-integer')
      ])
